import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  modal: {
    width: '584px',
    height: '232px',
    position: 'absolute',
    alignSelf: 'center',
    justifySelf: 'center',
  },
}));

export default useStyles;
